import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("CASH_RESERVES");
const CRUD_ACTION_HANDLERS = getActionHandler("CASH_RESERVES");

export default function cashReserves(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
